module.exports = __webpack_public_path__ + "static/media/last-price.6da6aded.jpg";